<template>
  <div v-if="show" class="modal-overlay" @click.self="closeModal">
    <div class="modal-container">
      <div class="modal-header">
        <h3>Создание нового запроса</h3>
        <button class="close-button" @click="closeModal">
          &times;
        </button>
      </div>

      <div class="modal-body">
        <form @submit.prevent="submitForm" class="request-form">
          <div class="form-group">
            <label for="title">Название запроса *</label>
            <input
              id="title"
              v-model="formData.title"
              type="text"
              placeholder="Введите название запроса"
              required
              class="form-input"
            >
          </div>

          <div class="form-group">
            <label for="text">Описание *</label>
            <textarea
              id="text"
              v-model="formData.text"
              placeholder="Опишите детали запроса"
              required
              class="form-textarea"
              rows="4"
            ></textarea>
          </div>

          <div class="form-group">
            <label for="status">Статус</label>
            <select
              id="status"
              v-model="formData.status"
              class="form-select"
            >
              <option value="1">Новый</option>
              <option value="2">В ожидании</option>
              <option value="3">КП отправлено</option>
              <option value="4">Отменен</option>
            </select>
          </div>

          <div class="form-group">
            <label for="timer">Дедлайн</label>
            <input
              id="timer"
              v-model="formData.timer"
              type="datetime-local"
              class="form-input"
            >
            <small class="form-hint">Установите дату и время окончания</small>
          </div>

          <div class="form-group">
            <label for="id_org">Организация *</label>
            <select
              id="id_org"
              v-model="formData.id_org"
              required
              class="form-select"
            >
              <option value="" disabled selected>Выберите организацию</option>
              <option
                v-for="org in organizations"
                :key="org.id_org"
                :value="org.id_org"
              >
                {{ org.org }}
              </option>
            </select>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn-secondary" @click="closeModal">
          Отмена
        </button>
        <button type="submit" class="btn-primary" @click="submitForm">
          Создать запрос
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateRequestModal',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    organizations: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      formData: {
        title: '',
        text: '',
        status: 1,
        timer: '',
        id_org: '',
      },
    };
  },

  watch: {
    show(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },

    submitForm() {
      if (!this.validateForm()) {
        return;
      }

      const requestData = {
        ...this.formData,
        timer: this.formData.timer ? new Date(this.formData.timer).toISOString() : null,
      };

      this.$emit('submit', requestData);
      this.closeModal();
    },

    validateForm() {
      if (!this.formData.title.trim()) {
        alert('Пожалуйста, введите название запроса');
        return false;
      }

      if (!this.formData.text.trim()) {
        alert('Пожалуйста, введите описание запроса');
        return false;
      }

      if (!this.formData.id_org) {
        alert('Пожалуйста, выберите организацию');
        return false;
      }

      return true;
    },

    resetForm() {
      this.formData = {
        title: '',
        text: '',
        status: '1',
        timer: '',
        id_org: '',
      };
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.modal-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease;
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafc;
  border-radius: 8px 8px 0 0;
}

.modal-header h3 {
  margin: 0;
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}

.modal-body {
  padding: 24px;
}

.modal-footer {
  padding: 20px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: #f8fafc;
  border-radius: 0 0 8px 8px;
}

.request-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
}

.form-input,
.form-textarea,
.form-select {
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: all 0.2s;
  background-color: white;
}

.form-input:focus,
.form-textarea:focus,
.form-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.form-select {
  cursor: pointer;
  appearance: none;
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
}

.form-hint {
  color: #6b7280;
  font-size: 0.75rem;
  margin-top: 4px;
}

.btn-primary,
.btn-secondary {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn-primary {
  background-color: #3b82f6;
  color: white;
}

.btn-primary:hover {
  background-color: #2563eb;
}

.btn-primary:active {
  background-color: #1d4ed8;
}

.btn-secondary {
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}

.btn-secondary:hover {
  background-color: #e5e7eb;
}

.btn-secondary:active {
  background-color: #d1d5db;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 640px) {
  .modal-container {
    width: 95%;
    margin: 10px;
  }

  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 16px;
  }

  .modal-footer {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }
}
</style>
